import React from 'react'
import { FaLinkedinIn, FaYoutube } from 'react-icons/fa';
import { FaFacebookF, FaTwitter } from 'react-icons/fa6';
import { IoLocation } from 'react-icons/io5';
import { MdEmail } from 'react-icons/md';
import { PiPhoneCallFill } from "react-icons/pi";

const GetInTouchUs = () => {
    return (
        <div
            className='bg-[#121f22] grid xl:grid-cols-2 grid-cols-1 px-6 py-10 rounded-lg xl:gap-0 gap-4'>
            <div className='text-white'>
                <h1 className='text-3xl font-bold'>Get in Touch with Us</h1>
                <p className='text-gray-300 mt-2 '>We have dedicated departments to handle your queries.Listed below are the department email ids, you can write to us based on your requirements.</p>
                {/* <div className='mt-4 flex gap-2'>
                    <div className='bg-[#fee5b5] inline-block text-black p-1.5 rounded cursor-pointer'>
                        <FaFacebookF size={15} />
                    </div>
                    <div className='bg-[#fee5b5] inline-block text-black p-1.5 rounded cursor-pointer'>
                        <FaTwitter size={15} />
                    </div>
                    <div className='bg-[#fee5b5] inline-block text-black p-1.5 rounded cursor-pointer'>
                        <FaLinkedinIn size={15} />
                    </div>
                    <div className='bg-[#fee5b5] inline-block text-black p-1.5 rounded cursor-pointer'>
                        <FaYoutube size={15} />
                    </div>
                </div> */}
            </div>
            <div className='grid md:grid-cols-3 grid-cols-1 items-center gap-4 '>
                <div className='bg-[#7c96bd] flex flex-col gap-2 py-5 rounded-lg h-full md:px-0 px-2'>
                    <div className='bg-[#121f22] w-10 h-10 rounded-full flex items-center justify-center m-auto'>
                        <PiPhoneCallFill size={20} color='orange' />
                    </div>
                    <div className='text-white text-sm text-center'>
                        <p>+1 470 740 2777</p>
                    </div>
                </div>
                <div className='bg-[#7c96bd] flex flex-col gap-2 py-5 rounded-lg h-full md:px-0 px-2'>
                    <div className='bg-[#121f22] w-10 h-10 rounded-full flex items-center justify-center m-auto'>
                        <MdEmail size={20} color='orange' />
                    </div>
                    <div className='text-white text-sm text-center'>
                        <p>info@techmentee.com</p>
                    </div>
                </div>
                <div className='bg-[#7c96bd] flex flex-col gap-2 py-5 rounded-lg h-full md:px-0 px-2'>
                    <div className='bg-[#121f22] w-10 h-10 rounded-full flex items-center justify-center m-auto'>
                        <IoLocation size={20} color='orange' />
                    </div>
                    <div className='text-white text-sm text-center'>
                        <p>
                            2440 Old Milton Parkway, Suite 117, Alpharetta, GA - 30009
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GetInTouchUs;